import type { ReactElement } from 'react';
import styled from 'styled-components';
import { Tag } from '../../components';
import { FacebookIcon, YouTubeIcon, ZoomIcon } from './brand-icons';
import { EventVisibility } from './graphql';

/*
 * Props mirror the GraphQL field names (snake_case). The generated ScheduledEvent
 * type camel-cases these, but the runtime objects are keyed as queried, so the
 * card spreads the event in — matching how the legacy DestinationsList works.
 */
interface Props {
  stream_rtmp?: boolean | null;
  stream_youtube?: boolean | null;
  stream_facebook?: boolean | null;
  stream_live?: boolean | null;
  stream_zoom?: boolean | null;
  hidden?: boolean | null;
  visibility?: EventVisibility;
}

const List = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--white60);
  font-size: 14px;

  svg {
    display: block;
  }
`;

/*
 * Card destinations. LiveControl renders as a small neutral "LC" tag; the other
 * targets use their brand icon (Font Awesome brands, Zoom via inline SVG).
 * Private/hidden events show an eye-slash instead.
 */
export const Destinations = ({
  stream_rtmp,
  stream_youtube,
  stream_facebook,
  stream_live,
  stream_zoom,
  hidden,
  visibility
}: Props): ReactElement => {
  if (hidden || visibility === EventVisibility.Private) {
    return (
      <List>
        <i className='fas fa-eye-slash' />
      </List>
    );
  }

  return (
    <List>
      {stream_live && (
        <Tag size='small' className='cc-neutral' style={{ padding: '1px 5px', borderRadius: '5px' }}>
          LC
        </Tag>
      )}
      {stream_youtube && <YouTubeIcon />}
      {stream_facebook && <FacebookIcon />}
      {stream_rtmp && <i className='fas fa-signal-stream' />}
      {stream_zoom && <ZoomIcon />}
    </List>
  );
};
